module.exports = __webpack_public_path__ + "assets/login-v2-dark.c9fb1bd1.svg";